<div>
  <app-rec-address-search-header [recordCount]="recAddressResults.recordCount"></app-rec-address-search-header>
</div>
<div>
  <app-rec-address-search-grid></app-rec-address-search-grid>
</div>
